import { inject, ref, unref, watch, type MaybeRef } from 'vue'
import { GRID_HTTP_INJECTION_KEY, parsePageResult } from '@zoryn/components/grid'
import { normalizeLovResponse } from '@zoryn/hooks'
import type { HttpRequest } from '@zoryn/network'
import type { FilterPayloadNode } from '@zoryn/components/grid'
import type { LovOption } from '@zoryn/hooks'

const LOV_QUERY_URL = '/system/lov/queryByExamplePage'

export function buildRulesLovQueryFilters(lovType: string): FilterPayloadNode[] {
  return [{ operator: 'eq', field: 'lovType', value: lovType }]
}

export function useRulesLov(lovType: MaybeRef<string | undefined>) {
  const request = inject<HttpRequest | null>(GRID_HTTP_INJECTION_KEY, null)
  const options = ref<LovOption[]>([])
  const loading = ref(false)

  async function loadOptions() {
    const type = unref(lovType)
    if (!type || !request) {
      options.value = []
      return
    }

    loading.value = true
    try {
      const params: Record<string, unknown> = {
        currentPage: 1,
        pageSize: 9999,
        pageFlag: false,
        filters: JSON.stringify(buildRulesLovQueryFilters(type)),
      }
      const res = await request.get({ url: LOV_QUERY_URL, params })
      const { list } = parsePageResult(res as never)
      options.value = normalizeLovResponse(list)
    } catch {
      options.value = []
    } finally {
      loading.value = false
    }
  }

  watch(
    () => unref(lovType),
    () => {
      void loadOptions()
    },
    { immediate: true }
  )

  return {
    options,
    loading,
    reload: loadOptions,
  }
}
